import type { VideoFormat } from '@studio/contracts';

const GIB = 1024 * 1024 * 1024;
const MIB = 1024 * 1024;

/** 24020 -> "0:24.02"; whole seconds when centis is false -> "0:24". */
export function fmtTime(ms: number, centis = true): string {
  const totalS = ms / 1000;
  const m = Math.floor(totalS / 60);
  const s = totalS - m * 60;
  if (!centis) return `${m}:${String(Math.floor(s)).padStart(2, '0')}`;
  return `${m}:${s.toFixed(2).padStart(5, '0')}`;
}

/** "5 Sep, 07:19" this year; "23 Aug 2025, 07:19" otherwise. No seconds, ever. */
export function fmtWhen(iso: string): string {
  const d = new Date(iso);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  const day = d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
  const time = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${day}, ${time}`;
}

export function fmtBytes(n: number | null): string {
  if (n === null) return '';
  if (n >= GIB) return `${(n / GIB).toFixed(1)} GB`;
  return `${Math.round(n / MIB)} MB`;
}

/**
 * A clip's own shape, as an aspect class. Viewers open at this, so nothing is cropped until the viewer
 * deliberately asks for another shape; a clip that was never probed reads as wide.
 */
export function clipAspect(width: number | null, height: number | null): VideoFormat {
  if (!width || !height) return '16:9';
  return width > height ? '16:9' : width < height ? '9:16' : '1:1';
}
